import {css, Typography, useTheme} from '@mui/material';
import * as React from 'react';
import {GetStylesFunction} from 'src/js/common/types';
import {HierarchyTreeNode as HierarchyTreeNodeModel} from 'src/js/model/hierarchy_tree_children';

import {HierarchyNodeItem} from './HierarchyNodeItem';

interface OwnProps {
  node: HierarchyTreeNodeModel;
  onNodeClick?: (node: HierarchyTreeNodeModel) => void;
  tabIndex?: number;
  isItemHighlighted?: boolean;
  getOptionDisabled?: (row: any) => boolean;
}

type Props = OwnProps;

export const HierarchyNodeContent: React.FC<Props> = (props) => {
  const {
    node,
    onNodeClick,
    tabIndex = 0,
    isItemHighlighted,
    getOptionDisabled,
  } = props;
  const theme = useTheme();
  const styles = getStyles({theme});

  return (
    <Typography
      data-name={'hierarchy-node-content--item-wrapper'}
      variant={'value'}
      css={styles.dlHierarchyNodeContent}
    >
      <HierarchyNodeItem
        node={node}
        onNodeClick={onNodeClick}
        tabIndex={tabIndex}
        isItemHighlighted={isItemHighlighted}
        getOptionDisabled={getOptionDisabled}
      />
    </Typography>
  );
};

HierarchyNodeContent.displayName = 'HierarchyNodeContent';

const getStyles: GetStylesFunction = (options) => ({
  dlHierarchyNodeContent: css`
    display: flex;
    width: 100%;
    justify-content: flex-start;
    margin-left: 4px;
  `,
});
